
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from "../login-controlador";
    import { Email } from '@/__env/ext';
    import { mask } from 'vue-the-mask';

    @Component( {
        name: "Componente",
        directives: { mask },
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {
        get Controlador() { return Model.Recuperar; }
        get UsuarioActual() { return Model.Recuperar.UsuarioActual; }

        Estado: 'cargando' | 'iniciado' = 'iniciado';
        Error: string = '';
        Codigo: string = '';

        public async Comprobar()
        {
            this.Estado = 'cargando';
            let response = await this.Controlador.Comprobar( this.Codigo.replace( '-', '' ) );

            if ( response != "ok" )
            {
                if ( response === "completado" )
                {
                    this.Error = 'Este codigo ya fue utilizado.';
                }
                else if ( response === "expirado" )
                {
                    this.Error = 'Este codigo expiró. Intenta nuevamente';
                } else if ( response === 'sesion-expirada' )
                {
                    this.Error = 'Tu sesión expiró. Intenta nuevamente';
                }
                else if ( response === "datos-incorrectos" )
                {
                    this.Codigo = '';
                    this.Error = '¡El codigo es incorrecto!';
                }
                else
                {
                    this.Error = 'Ocurrió un error en el servicio';
                }
            }
            this.Estado = 'iniciado';

        }


        public async Reenviar()
        {
            this.Estado = 'cargando';
            let response = await this.Controlador.Enviar( '', true );
            if ( response != "enviado" )
            {
                this.Error = 'Ocurrió un error en el servicio';
            }
            document.getElementById( 'text-codigo' ).focus();
            this.Estado = 'iniciado';
        }

    }
